import React from 'react';
import {SlideBaseRenderer} from './slide-base.renderer';
import {LiveStreamHlsPocSlideComponent} from '../../../components/video-slides/components/live-stream-slide/live-stream-hls-poc-slide.component';
import {GameInfo} from "../../games/game-info";

export class LiveStreamGameSlideRenderer extends SlideBaseRenderer {
    constructor(private readonly gameInfo: GameInfo) {
        super();
    }

    get uniqueKey(): string {
        return this.gameInfo.gameType.toString()
    }

    render(): React.ReactElement {
        return (<LiveStreamHlsPocSlideComponent key={this.uniqueKey} gameInfo={this.gameInfo} />);
    }
}
